import { DataBaseModelInterface } from '@solcre-org/core';

export class ArchiveTariffFormModel implements DataBaseModelInterface {
  constructor(public reason: string = '') {}

  fromJSON(json: any): ArchiveTariffFormModel {
    if (json) {
      this.reason = json.reason ?? '';
    }
    return this;
  }

  toJSON() {
    return { reason: this.reason };
  }

  getId() {
    return this.reason;
  }

  getReference() {
    return this.reason;
  }
}
